import { getCatalogueLinkWithoutFilters } from 'apps/catalogue/links';

const getPreparedCatalogueLink = ({ categoryIndex, pageParameters, basePath, categories, sliceEnding = true }) =>
  getCatalogueLinkWithoutFilters({
    ...pageParameters,
    category: sliceEnding ? categories.slice(0, categoryIndex + 1) : categories,
    sort: '',
  }, basePath);

export const getCategoryChildCategories = (category, childCategories, buildLinkOptions) => {
  const categoryChildCategories = Array.isArray(childCategories) &&
    childCategories.find((childCategory) => childCategory.id === category.id);

  if (!categoryChildCategories || !categoryChildCategories.children) {
    return null;
  }

  const { basePath, index, pathCategories = [], pageParameters } = buildLinkOptions;

  return categoryChildCategories.children.map((childCategory) => ({
    id: childCategory.id,
    name: childCategory.name,
    link: getPreparedCatalogueLink({
      categoryIndex: index,
      pageParameters,
      basePath,
      categories: pathCategories.slice(0, index + 1).concat(childCategory),
      sliceEnding: false,
    }),
  }));
};

export const getCategoryBreadcrumbs = ({ basePath, pageParameters, childCategories = [] }) => {
  const { category: categories } = pageParameters;

  if (!categories || categories.length < 1) {
    return [];
  }

  return categories.map((category, index) => ({
    id: category.id,
    name: category.name,
    link: getPreparedCatalogueLink({ categoryIndex: index, pageParameters, basePath, categories }),
    menuCategories: getCategoryChildCategories(category, childCategories, {
      index,
      pageParameters,
      basePath,
      pathCategories: categories,
    }),
  }));
};

export const getLastCategoryName = ({ category: categories }) => {
  if (!categories || categories.length < 1) {
    return null;
  }

  const lastCategory = categories[categories.length - 1];

  return lastCategory.name;
};
